export default __webpack_public_path__ + "static/media/search_dropdown.c29cc3a6.svg";